module.exports = __webpack_public_path__ + "static/media/sanar-up.3955b314.svg";